import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import {
  StickyObserverDirective,
  StickyObserverEvent
} from '@directives/sticky-observer/sticky-observer.directive';
import { DEFAULT_PAGE_TITLE_STATE, PageTitleState } from '@models/layout-state.model';
import { QuickNavComponent } from '@shared-components/quick-nav/quick-nav.component';
import { ViewService } from 'tangoe-design-system';

@Component({
  selector: 'ts-fluid-page-title',
  templateUrl: './fluid-page-title.component.html',
  imports: [CommonModule, QuickNavComponent, StickyObserverDirective]
})
export class FluidPageTitleComponent {
  @Input() state: PageTitleState = { ...DEFAULT_PAGE_TITLE_STATE };
  @Input() content: TemplateRef<any> | null = null;

  constructor(private view_svc: ViewService) {}

  onStick(event: StickyObserverEvent) {
    this.view_svc.toggleClassWithAnimationFrame(event.elt, 'is-stuck', event.stuck);
  }
}
